define('v3/Common/Bindings/EmptyPlaceholder.Binding',[
	'knockout',
	'v3/Common/Services/frontend/Frontend.Service'
], function (ko, frontend) {
	ko.bindingHandlers.empty = {
		update: function (el, valueAccessor) {
			var params = ko.unwrap(valueAccessor());

			if (ko.unwrap(params.placeholder)) {
				frontend.placeholder.show(el);
			} else {
				frontend.placeholder.hide(el);
			}
		}
	};
});

